import { IKnmLinkType } from 'APIPackage/CatalogsModule/interfaces/IKnmLinkType';

export const createKnmLinkTypeSelectOption = (knmLinkType: IKnmLinkType) => ({
  ...knmLinkType,
  label: knmLinkType.name,
  value: knmLinkType.code,
});
